define('gigaset_recurring/main',[
	"require",
	"lodash",
	"cartware/components/Registry",
	"json!./handles/gigaset_recurring.json"
], function(
	require,
	_,
	Registry,
	Handles
) {
	return {
		bootstrap: function() {
			this.bootstrapDispatcher();
		},

		bootstrapDispatcher: function() {
			Registry().retrieve("component.dispatcher", function(dispatcher) {
				_.forEach(Handles, function(components, handle) {
					require(components, function() {
						var handleMapApply = {};
						handleMapApply[handle] = Array.prototype.slice.call(arguments, 0);

						dispatcher.applyHandles(handleMapApply);
					});
				});
			});
		}
	};
});
define('gigaset_recurring', ['gigaset_recurring/main'], function (main) { return main; });

